/* eslint-disable @typescript-eslint/no-explicit-any */
import { ContextEngine } from '@/types';
import { hashString } from '../utils/url';

export function readCache(
  storage: Storage | null,
  disableCache: boolean,
  cacheTTL: number,
  url: string
): ContextEngine.ContextResult | null {
  if (!storage || disableCache) return null;
  try {
    const key = hashString(url);
    const raw = storage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as {
      ts: number;
      ttl: number;
      value: ContextEngine.ContextResult;
    };
    if (!parsed?.ts) return null;
    if (Date.now() - parsed.ts > (parsed.ttl || cacheTTL)) {
      storage.removeItem(key);
      return null;
    }
    return parsed.value;
  } catch {
    storage?.removeItem(hashString(url));
    return null;
  }
}

export function writeCache(
  storage: Storage | null,
  disableCache: boolean,
  cacheTTL: number,
  url: string,
  value: ContextEngine.ContextResult,
  onError: (message: string) => void
): void {
  if (!storage || disableCache) return;
  try {
    const key = hashString(url);
    const payload = { ts: Date.now(), ttl: cacheTTL, value };
    storage.setItem(key, JSON.stringify(payload));
  } catch (e: any) {
    onError(e?.message || 'unknown');
  }
}

export function clearCache(
  storage: Storage | null,
  disableCache: boolean,
  url: string
): void {
  if (!storage || disableCache) return;
  const key = hashString(url);
  storage.removeItem(key);
}
